// extracted by mini-css-extract-plugin
export default {"insetBtn":"InsetBtn_insetBtn__N+t2n"};